function googleAnalyticsStub(): void {
  googleAnalyticsStubFunction.q = googleAnalyticsStubFunction.q || [];
  // eslint-disable-next-line prefer-rest-params
  googleAnalyticsStubFunction.q.push(arguments);
}

const googleAnalyticsStubFunction: GoogleAnalyticsFunction = googleAnalyticsStub;

window.GoogleAnalyticsObject = 'ga';
window.ga = window.ga || googleAnalyticsStubFunction;

const googleAnalytics = window.ga;
googleAnalytics.l = Date.now();

const script = document.createElement('script');
script.async = true;
script.src = 'https://www.google-analytics.com/analytics.js';

const firstScript = document.getElementsByTagName('script')[0];
firstScript.parentNode!.insertBefore(script, firstScript);

export {};
